import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center w-full min-h-[44px] bg-zbr-black-900 text-center text-white font-oswald"
}

import { useScreenSize } from '@/composables/useScreenSize';

export default /*#__PURE__*/_defineComponent({
  __name: 'VehicleSearchBox',
  props: {
    title: {},
    tablet: { type: Boolean },
    minHeight: {},
    wrapperClass: {},
    scrollClass: {},
    scrollHeight: {}
  },
  setup(__props: any) {



const { isTablet, isDesktop } = useScreenSize();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      _ctx.wrapperClass ? _ctx.wrapperClass : 'flex flex-col w-full min-h-full max-h-full bg-white',
      _unref(isDesktop) ? 'border border-zbr-gray-20' : null
    ])
  }, [
    (_unref(isDesktop) && _ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_unref(isDesktop) && _ctx.$slots.title)
      ? _renderSlot(_ctx.$slots, "title", { key: 1 })
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        _ctx.scrollClass ? _ctx.scrollClass : 'px-8 py-6 relative flex flex-col overflow-hidden'
      ]),
      style: _normalizeStyle({
        minHeight: _ctx.scrollHeight
          ? _ctx.scrollHeight
          : _unref(isTablet)
            ? ''
            : 'calc(100% - 44px)'
      })
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 6)
  ], 2))
}
}

})